import React from "react";
import { BoringAvatar } from "@bandit-network/react-ui-kit";
import { truncateAddress } from "@bandit-network/utils";

export interface ParticipantsTableProps {
  addresses: Array<string>;
}

const ParticipantsTable: React.FC<ParticipantsTableProps> = ({ addresses }) => {
  return (
    <div className="bad-quest__participants--content">
      <div className="bad-quest__participants">
        {addresses.map((address, index) => (
          <div className="bad-quest__participants--item" key={index}>
            <BoringAvatar name={address} size={24} />
            <p className="bad-quest__participants--item_address">
              {truncateAddress(address, 6)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ParticipantsTable };
